import { useState, useEffect } from 'react';
import './Nav.css';

export default function Nav({ onOpenModal }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <nav className={`nav${scrolled ? ' scrolled' : ''}`}>
      <a href="#top" className="nav-logo">
        <span>TAG</span><span>pdf</span>
      </a>
      <ul className="nav-links">
        <li><a href="#features">Features</a></li>
        <li><a href="#pipeline">Pipeline</a></li>
        <li><a href="#technical">Stack</a></li>
        <li><a href="#privacy">Privacy</a></li>
      </ul>
      <button className="nav-cta" onClick={onOpenModal}>Early Access</button>
    </nav>
  );
}
